var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.966 6.02422V20.582C18.966 21.3641 18.3301 22 17.548 22H4.45117C3.66914 22 3.0332 21.3641 3.0332 20.582V1.41797C3.0332 0.635937 3.66914 0 4.45117 0H12.9418L18.966 6.02422Z",
    fill: "#0A8080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92773 11.0547H15.0746V11.9613H6.92773V11.0547ZM6.92773 13.0742H15.0746V13.9809H6.92773V13.0742ZM6.92773 15.098H15.0746V16.0047H6.92773V15.098ZM6.92773 17.1176H12.7242V18.0242H6.92773V17.1176Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7637 5.79258L18.9672 10.0078V6.04609L16.0195 4.33594L13.7637 5.79258Z",
    fill: "black",
    fillOpacity: 0.0980392
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9676 6.02422H14.3613C13.5793 6.02422 12.9434 5.38828 12.9434 4.60625V0L18.9676 6.02422Z",
    fill: "#268E8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.f734447ea2d598e3fbf321ddd90847ea.svg";
export { ForwardRef as ReactComponent };